module.exports = __webpack_public_path__ + "img/page1-bg.136bf44f.png";